import Checkbox, { CheckboxProps } from "@mui/material/Checkbox";
import CheckedIcon from "../../icons/CheckedIcon";
import UncheckedIcon from "../../icons/UncheckedIcon";

interface CheckboxButtonProps {
  squareIcon?: boolean;
}

export const StyledCheckbox = ({
  squareIcon = false,
  ...props
}: CheckboxProps & CheckboxButtonProps) => (
  <Checkbox
    checkedIcon={<CheckedIcon square={squareIcon} />}
    icon={<UncheckedIcon square={squareIcon} />}
    {...props}
  />
);

export default StyledCheckbox;
